export class WebFormSubmission {
  formId: string;
  watermark: boolean;
  pdfUrl: string;
  meta: string;
  signers: WebFormSigner[];
  entries: WebFormEntry[];
}

export class WebFormSigner {
  email: string;
  firstName: string;
  middleName: string;
  lastName: string;
  phone: string;

  constructor(email: string, firstName: string, middleName: string, lastName: string, phone: string) {
    this.email = email;
    this.firstName = firstName;
    this.middleName = middleName;
    this.lastName = lastName;
    this.phone = phone;
  }
}

export class WebFormEntry {
  type: string;
  id: string;
  value: string;
  isRequired: boolean;
  isIgnoredField: boolean;
  metaData: string;

  constructor(type: string, id: string, value: string, isRequired: boolean, isIgnoredField: boolean, metaData: string = '') {
    this.type = type;
    this.id = id;
    this.value = value;
    this.isRequired = isRequired;
    this.isIgnoredField = isIgnoredField;
    this.metaData = metaData;
  }
}
